import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// --- ADICIONE ESTAS DUAS LINHAS ---
import LightboxController from "./lightbox_controller.js"
application.register("lightbox", LightboxController)
// ----------------------------------

export { application }
